import { useSelector } from "react-redux";
import React, { memo, useMemo } from "react";
import ResponsiveIframe from "../../components/IFrame";
import FullPageError from "../../components/FullPageError";
import { useIsUrlValid } from "../../hooks/useIsUrlValid";

function WalletPage() {
  const walletConfig = useSelector((state) => state.walletConfig);
  const { config } = walletConfig || {};
  const { walletUrl, walletApiKey } = config || {};

  const activeDivisionId = useSelector(
    (state) => state.storage?.activeDivisionId
  );

  const isIframeUrlValid = useIsUrlValid(walletUrl);
  const isConfigInvalidError = useMemo(() => {
    return !(walletConfig && walletUrl && isIframeUrlValid);
  }, [walletConfig, walletUrl, isIframeUrlValid]);

  const sendApiKey = (iframeRef) => {
    const origin = new URL(iframeRef.current.src).origin;
    setTimeout(() => {
      iframeRef.current.contentWindow.postMessage(
        { type: "API_KEY", key: walletApiKey },
        origin
      );
    }, 50);
  };

  const mainErrorVerbiage = "Configuration for Wallet is missing or incorrect";
  const supportErrorVerbiage = "Please ";

  return (
    <>
      {isConfigInvalidError ? (
        <FullPageError
          mainErrorVerbiage={mainErrorVerbiage}
          supportErrorVerbiage={supportErrorVerbiage}
        />
      ) : (
        <ResponsiveIframe
          src={walletUrl}
          apiKeyFunc={walletApiKey ? sendApiKey : undefined}
          key={activeDivisionId}
        />
      )}
    </>
  );
}
export default memo(WalletPage);
